const heroSliders = document.querySelectorAll('.c-slider-wrap.hero');
if(heroSliders.length > 0) {
  heroSliders.forEach(slider => {
    new Swiper(slider.querySelector('.c-slider'), {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      speed: 900,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: slider.querySelector('.c-slider-arrow.next'),
        prevEl: slider.querySelector('.c-slider-arrow.prev'),
      },
      pagination: {
        el: slider.querySelector('.c-slider-pagination'),
        clickable: true,
      },
    });
  });
}